import { render } from "./SnowflakeAuthenticationRadioCard.vue?vue&type=template&id=3134295b"
import script from "./SnowflakeAuthenticationRadioCard.vue?vue&type=script&lang=js"
export * from "./SnowflakeAuthenticationRadioCard.vue?vue&type=script&lang=js"

import "./SnowflakeAuthenticationRadioCard.vue?vue&type=style&index=0&id=3134295b&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__